<template>
  <div>
    <telephony-operators-report-header @generate="generate" @filterChanged="filterChanged"
    @onChangedDateStart="onChangedDateStart" @onChangedDateEnd="onChangedDateEnd"
    :filterOptions="filterOptions" :isGenerateDisabled="isGenerateDisabled" @paginationChanged="paginationChanged"/>

    <basic-table
      :items="reportInvoices"
      :fields="reportInvoicesFields"
      :filter="filter"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"/>
    <table-manager-bottom
    :totalRows="totalRows" :perPage="perPage"
    v-model="currentPage"/>
  </div>
</template>

<script>

export default {
  props: {
    editItem: null
  },
  data () {
    return {
      num: 0,
      reportInvoices: [],
      reportInvoicesFields: [
        {key: 'num', label: this.$i18n.t('Row number'), sortable: true},
        {key: 'alt_number', label: this.$i18n.t('Supplier contract number'), sortable: true},
        {key: 'account_id', label: this.$i18n.t('Client contract number'), sortable: true},
        {key: 'invoice_id', label: this.$i18n.t('Invoice number'), sortable: true},
        {key: 'alt_number', label: this.$i18n.t('Act number'), sortable: true},
        {key: 'invoice_date', label: this.$i18n.t('Invoice date'), sortable: true, formatter: (val, key, item) => { return this.$root.showDataWithTZDelta(val) }},
        {key: 'expire_date', label: this.$i18n.t('Expire pay date'), sortable: true, formatter: (val, key, item) => { return this.$root.showDataWithTZDelta(val) }},
        {key: 'i', label: this.$i18n.t('Currency'), sortable: true},
        {key: 'vat_rate', label: this.$i18n.t('Vat code'), sortable: true},
        {key: 's', label: this.$i18n.t('Service code'), sortable: true},
        {key: 'd', label: this.$i18n.t('Service date'), sortable: true},
        {key: 'cost', label: this.$i18n.t('Cost'), sortable: true},
        {key: 'g', label: this.$i18n.t('Quantity'), sortable: true},
        {key: 'service_place', label: this.$i18n.t('Service place'), sortable: true},
        {key: 'include_vat', label: this.$i18n.t('Include vat'), sortable: true}
      ],
      isGenerateDisabled: false,
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      dateStart: this.$root.setDataWithSelectedTZ().toDate(),
      dateEnd: this.$root.setDataWithSelectedTZ().toDate(),
      currentTab: 1,
      filterOptions: {
        isFilterGroup: false,
        isFilterTypeTraffic: false,
        isFilterTypeDocuments: false,
        isFilterTypeUsers: false,
        isFilterCollector: false
      }
    }
  },
  methods: {
    async generate () {
      this.num = 0
      this.isGenerateDisabled = true
      let generate = {
        numDateEnd: 0,
        numDateStart: 0,
        supplier_id: 0
      }
      generate.numDateEnd = Number(this.dateEnd) / 1000
      if (generate.numDateEnd > 2147483647) generate.numDateEnd = 2147483647
      generate.numDateStart = Number(this.dateStart) / 1000
      if (generate.numDateStart > 2147483647) generate.numDateStart = 2147483647
      generate.supplier_id = this.editItem.id
      let reportInvoices = await this.$store.dispatch('Settings/GET_REPORT_INVOICES', generate)
      this.reportInvoices = reportInvoices.data
      for (let el of this.reportInvoices) {
        el.num = ++this.num
        el.include_vat = el.vat_rate + el.cost
      }
      this.loadDone()
    },
    onChangedDateStart (value) {
      this.dateStart = value
    },
    onChangedDateEnd (value) {
      this.dateEnd = value
    },
    filterChanged (value) {
      this.filter = value
    },
    loadDone () {
      this.isGenerateDisabled = false
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  mounted () {
    this.loadDone()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/telephony/telephoneOperators/reportInvoices.vue